/**
 * 年度预算计划拷贝
 * chenxiaojian 2021-01-04
 */

import React, { Component } from 'react';
import { Modal, Form, Input, Select } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';
import Loading from '../../ui/Loading';

const fields = [{
    "text": "复制源计划年份",
    "field": "sourceYear",
    "year": true,
    rules: [
        { required: true, message: '复制源计划年份不能为空!' },
    ]
}, {
    "text": "生成计划年份",
    "field": "targetYear",
    "year": true,
    rules: [
        { required: true, message: '生成计划年份不能为空!' },
    ]
}]

class YearBudgetCopyForm extends Component {

    state = {
        loadingVisible: false,
    }


    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            this.setState({ loadingVisible: true });
            if (err) {
                this.setState({ loadingVisible: false });
                return;
            }
            http.post({
                url: '/yearBudget/copyYearBudget',
                data: values,
                success: (res) => {
                    this.setState({ loadingVisible: false })
                    let queryData = this.props.queryData;
                    this.props.successCallback(queryData);
                    this.props.onCancel();
                    messager.notify("拷贝年度计划成功！");
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false })
                }
            });
        });
    };



    createDom = (data) => {
        const { form, editData, yearList } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: editData[item.field],
                        })(
                            item.year ?
                                <Select>
                                    {yearList.map(item => (
                                        <Select.Option key={item}>{item}</Select.Option>
                                    ))}
                                </Select>
                                : <Input disabled={item.disabled === true} />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="年度计划复制"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    {this.createDom(fields)}
                </Form>
                <Loading visible={this.state.loadingVisible} message="处理中，请稍候..." />
            </Modal>
        );
    }
}

const YearBudgetCopy = Form.create()(YearBudgetCopyForm);

export default YearBudgetCopy;
